import { render } from "./generalMessage.vue?vue&type=template&id=3b26c781"
import script from "./generalMessage.vue?vue&type=script&lang=js"
export * from "./generalMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__